import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationGuard } from './core/guards/authorization.guard';
import { Rights } from './core/services/api-services';
import { SiteTemplateComponent } from './shared/containers/site-template/site-template.component';

const routes: Routes = [
  {
    path: '',
    component: SiteTemplateComponent,
    children: [
      {
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthorizationGuard],
        data: {
          rights: [Rights.SystemAdministrator]
        },
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthorizationGuard],
      },      
      {
        path: '',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
      },
    ]
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
  },
  {
    path: '**',
    redirectTo: 'account/login',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking' // Important for Angular Universal to also render child routes on server side
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
